
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#ef5350","stroke-linecap":"round","stroke-linejoin":"round","data-name":"vuesax/twotone/danger"}},[_c('path',{attrs:{"d":"M17 12.749v7.086","stroke-width":"1.5","opacity":".34"}}),_c('path',{attrs:{"data-name":"Vector","d":"M17 30.329H8.415c-4.915 0-6.969-3.513-4.59-7.8l4.42-7.961 4.165-7.484c2.521-4.547 6.658-4.547 9.179 0l4.165 7.49 4.42 7.961c2.38 4.292.312 7.8-4.59 7.8H17z","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16.992 24.083h.013","stroke-width":"2","opacity":".34"}})])])
          )
        }
      }
    